import { render, staticRenderFns } from "./projectManager.vue?vue&type=template&id=28c0dbc3&scoped=true"
import script from "./projectManager.vue?vue&type=script&lang=ts"
export * from "./projectManager.vue?vue&type=script&lang=ts"
import style0 from "./projectManager.vue?vue&type=style&index=0&id=28c0dbc3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c0dbc3",
  null
  
)

export default component.exports